export default __webpack_public_path__ + "static/media/oasisMap.75e171ce.png";